import React from 'react';
import { Card } from 'react-bootstrap';
import './bloodwork-anemia-status.css';
import { LabsmartsGuage } from '../charts/LabsmartsGauge';
import { BloodworkAnalysis } from '../../models/BloodworkAnalysis';
import {
  dehydrationGauge,
  DehydrationGauge,
  DehydrationMarker,
} from '../../models/DehydrationGauge';

const arrow_up = require('../../assets/imgs/long-arrow-up-8x13.png');
const arrow_down = require('../../assets/imgs/long-arrow-down-8x12.png');

// Same arrow / list styling as GlucoseRegulationInsights so the two panels read
// as one design.
const arrowStyle: React.CSSProperties = {
  height: '11px',
  margin: '0 3px',
  verticalAlign: 'middle',
  position: 'relative',
  top: '-0.5px',
};

const conditionTitleStyle: React.CSSProperties = {
  color: 'black',
  textAlign: 'left',
};

const markerStyle: React.CSSProperties = {
  color: 'black',
  textAlign: 'right',
};

type Props = {
  bloodworkAnalysis: BloodworkAnalysis;
};

export class DehydrationInsights extends React.Component<Props, {}> {
  // Whether this panel will render anything, so the parent can drop the eval
  // Col entirely and let the Results panel left-align (same contract as
  // GlucoseRegulationInsights.shouldRender).
  static shouldRender(ba: BloodworkAnalysis): boolean {
    if (!ba?.bloodwork) return false;
    return dehydrationGauge(ba) !== null;
  }

  renderArrow(marker: DehydrationMarker) {
    const src = marker.direction === 'up' ? arrow_up : arrow_down;
    const alt = marker.direction === 'up' ? '↑' : '↓';
    return (
      <span
        style={{ whiteSpace: 'nowrap' }}
        key={`${marker.direction}-${marker.label}`}
      >
        <img src={src} alt={alt} style={arrowStyle} />
        {marker.label}
      </span>
    );
  }

  renderPattern(gauge: DehydrationGauge) {
    if (!gauge.markers.length) return null;
    const title =
      gauge.type === 'chronic'
        ? 'Chronic pattern — hemoconcentration with raised protein / BUN'
        : gauge.type === 'acute'
        ? 'Acute pattern — hemoconcentration with raised sodium'
        : 'Hemoconcentration pattern';
    return (
      <div className="condition-section">
        <div style={conditionTitleStyle}>{title}</div>
        <div style={markerStyle}>
          {gauge.markers.map(marker => this.renderArrow(marker))}
        </div>
      </div>
    );
  }

  render() {
    const { bloodworkAnalysis } = this.props;
    const gauge = dehydrationGauge(bloodworkAnalysis);
    if (!gauge || !bloodworkAnalysis?.bloodwork) return null;

    return (
      <Card className="evaluationPanel" id="dehydration-insights">
        <Card.Header className="evaluationPanelHeading">
          Hydration Insights
        </Card.Header>
        <Card.Body>
          <div className="anemiaStatusContainer">
            <LabsmartsGuage
              text={gauge.text}
              chartContainerId="dehydrationGuage"
              bloodwork={bloodworkAnalysis.bloodwork}
              probability={gauge.probability}
              category={gauge.category}
              ticks={[0, 50, 70, 90]}
            />
            {this.renderPattern(gauge)}
          </div>
        </Card.Body>
      </Card>
    );
  }
}
